import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import {
  AccionesRol,
  CategoriaRecordatorio,
  IFilter,
  IPopulate,
  IQueryParam,
  IRecordatorio,
} from 'modelos/src';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { RecordatoriosService } from '../../../../auxiliares/servicios/http/recordatorios.service';
import { LoginService } from '../../../login/login.service';
import {
  IColumnas,
  ICrearBoton,
  TablaComponent,
} from '../../../../auxiliares/tabla/tabla.component';
import {
  IFiltroTabla,
  IRegExpSearch,
} from '../../../../auxiliares/tabla/filtro/filtro.component';

import { HelperService } from '../../../../auxiliares/servicios/helper.service';
import { DialogService } from '../../../../auxiliares/dialog/dialog.service';
import { Lista2Service } from '../../../../auxiliares/servicios/lista2.service';

import { MatDialogModule } from '@angular/material/dialog';
import { ClienteJerarquiaService } from '../../../../auxiliares/servicios/cliente-jerarquia.service';
import { fechaCelda } from '../../../../auxiliares/tabla/celdas';

@Component({
  selector: 'app-listado-recordatorios',
  templateUrl: './listado-recordatorios.component.html',
  styleUrl: './listado-recordatorios.component.scss',
  standalone: true,
  imports: [TablaComponent, MatDialogModule],
})
export class ListadoRecordatoriosComponent implements OnInit, OnDestroy {
  private clienteJerarquia = inject(ClienteJerarquiaService);
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);
  private dialogService = inject(DialogService);
  private service = inject(RecordatoriosService);
  private navigator = inject(Router);
  private route = inject(ActivatedRoute);

  public idUsuario = LoginService.getUsuario()?._id;
  //// Tabla nueva
  public name = 'ListadoRecordatoriosComponent';
  public recordatorios?: IRecordatorio[];
  public totalCount = 0;
  public columnas?: IColumnas<IRecordatorio>[];

  /** Categoría del recordatorio. Por ruta en la página, por Input si se embebe. */
  @Input() categoria: CategoriaRecordatorio;

  /**
   * Cuando se embebe en el detalle de un activo: filtra por ese activo y el
   * alta/edición navegan a la ruta absoluta (dentro del tab no hay rutas
   * hijas 'crear'/'editar' a las que ir relativo).
   */
  @Input() idActivo?: string;

  /**
   * Cliente del activo. Va junto con `idActivo` al formulario de alta: sin el
   * cliente, el selector de vehículos del form no carga opciones y el activo
   * preseleccionado no matchea nada.
   */
  @Input() idCliente?: string;
  //Subs
  public recordatorios$?: Subscription;

  //Permisos
  private puedeCrear: AccionesRol;
  private puedeEditar: AccionesRol;
  private puedeEliminar: AccionesRol;

  public botonCrear: ICrearBoton;

  public search: IRegExpSearch = {
    fields: ['tipo'],
  };
  // FILTROS
  public cliente: IFiltroTabla = {
    filter: {
      field: 'idCliente',
    },
    label: 'Cliente',
    tipo: 'cliente-selector',
  };
  // Cliente en cuya jerarquía cuelga la entidad: el cliente elegido y toda su
  // descendencia.
  public ancestro: IFiltroTabla = {
    filter: {
      field: 'idsAncestros',
      incluirPropio: true,
    },
    label: 'En la jerarquía de',
    tipo: 'cliente-selector',
  };
  public filtros: IFiltroTabla[] = [];
  //Query
  public filter: IFilter<IRecordatorio> = {};
  public populate: IPopulate[] = [
    {
      path: 'usuario',
      select: 'nombre',
    },
    {
      path: 'documentacion',
      populate: {
        path: 'activo chofer',
        select: 'identificacion usuario',
      },
    },
    {
      path: 'activo',
      select: 'identificacion',
    },
    {
      path: 'cliente',
      select: 'nombre',
    },
  ];
  public query: IQueryParam = {
    filter: JSON.stringify(this.filter),
    populate: JSON.stringify(this.populate),
    sort: 'nombre',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: true,
    childrenLevel: 0,
  };
  // Listars
  public async listar(): Promise<void> {
    const filter: IFilter<IRecordatorio> = this.query.filter
      ? JSON.parse(this.query.filter)
      : {};
    filter.categoria = this.categoria;
    if (this.idActivo) filter.idActivo = this.idActivo;
    this.query.filter = JSON.stringify(filter);

    this.recordatorios$?.unsubscribe();
    this.recordatorios$ = this.lista2
      .recordatorios(this.query, 30)
      .subscribe((data) => {
        this.totalCount = data.totalCount;
        this.recordatorios = data.datos;
      });
  }

  // Acciones
  public async crear() {
    if (this.idActivo) {
      // Embebido: ruta absoluta + activo preseleccionado en el formulario
      this.navigator.navigate([...this.rutaBase(), 'crear'], {
        queryParams: { idActivo: this.idActivo, idCliente: this.idCliente },
      });
      return;
    }
    this.navigator.navigate(['crear'], { relativeTo: this.route });
  }

  public async editar(recordatorio: IRecordatorio) {
    if (this.idActivo) {
      this.navigator.navigate([...this.rutaBase(), 'editar', recordatorio._id]);
      return;
    }
    this.navigator.navigate(['editar', recordatorio._id], {
      relativeTo: this.route,
    });
  }

  /**
   * Ruta del listado de recordatorios. Ojo: las dos categorías cuelgan del
   * módulo `colectivos` (ver colectivos/routing.ts), también las de Vehículo.
   */
  private rutaBase(): string[] {
    return ['/', 'main', 'colectivos', 'recordatorios', this.categoria];
  }

  public async eliminar(recordatorio: IRecordatorio) {
    const res = await this.dialogService.confirm(
      'Eliminar recordatorio',
      `¿Querés eliminar el recordatorio ${recordatorio.detallesDelMantenimiento}?`,
    );
    if (!res) return;
    try {
      await this.service.delete(recordatorio._id!);
      this.helper.notifSuccess('Recordatorio eliminado');
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  // Tabla

  private setColumnas() {
    this.columnas = [
      {
        header: {
          label: 'Entidad',
        },
        row: {
          parse(dato) {
            if (dato?.idActivo) {
              return dato?.activo?.identificacion;
            }
            if (dato?.documentacion) {
              if (dato?.documentacion?.idActivo) {
                return dato?.documentacion?.activo?.identificacion;
              }
              if (dato?.documentacion?.idChofer) {
                return dato?.documentacion?.chofer?.usuario;
              }
            }
            return '';
          },
          noData: 'Sin entidad',
        },
      },
      {
        header: {
          label: 'Recordar por',
        },
        row: {
          parse(dato) {
            const text: string[] = [];
            dato?.tipo?.forEach((r) => {
              if (r == 'fecha') text.push('Vencimiento');
              if (r == 'km') text.push('Kilometraje');
            });
            return text.join(', ');
          },
          noData: 'Sin tipo',
        },
      },
      {
        header: {
          label: 'Notificado',
          sortable: true,
          sort: 'notificado',
        },
        row: {
          estado: (dato) =>
            dato.notificado
              ? { texto: 'Notificado', tono: 'ok', icono: 'check_circle' }
              : { texto: 'No notificado', tono: 'info', icono: 'pending' },
        },
      },
      {
        header: {
          label: 'Recordar cuando',
        },
        row: {
          parse(dato) {
            const text: string[] = [];

            if (dato.fechaLimite) {
              // La hora sólo si no es 00:00 (fecha sin hora)
              const fecha = fechaCelda(dato.fechaLimite);
              text.push(fecha.endsWith(' 00:00') ? fecha.slice(0, 10) : fecha);
            }

            if (dato.kmLimite)
              text.push(`${dato.kmLimite.toLocaleString('es-AR')} km`);

            return text.join(' · ');
          },
          noData: 'Sin fecha ni kilometraje',
        },
      },
    ];
    // Cliente
    if (HelperService.getTipoCliente() !== 'Final') {
      {
        this.columnas.push({
          header: {
            label: 'Cliente',
          },
          row: {
            html: (dato) => this.clienteJerarquia.htmlNombre(dato.cliente),
            tooltip: (dato) =>
              this.clienteJerarquia.tooltipJerarquia(dato.cliente),
            noData: 'Sin cliente',
          },
        });
      }
    }

    // Acciones
    this.columnas.push({
      header: {
        label: 'Acciones',
      },
      row: {
        acciones: [
          {
            tipo: 'material',
            color: 'primary',
            icon: 'edit',
            tooltip: 'Editar',
            click: (dato) => this.editar(dato),
            disabled: () => !this.helper.tienePermiso(this.puedeEditar),
          },
          {
            tipo: 'material',
            color: 'warn',
            icon: 'delete',
            tooltip: 'Eliminar',
            click: (dato) => this.eliminar(dato),
            disabled: () => !this.helper.tienePermiso(this.puedeEliminar),
          },
        ],
      },
    });
  }

  // Hooks

  async ngOnInit() {
    // Embebido en el detalle de un activo: no hay params de ruta, la categoría
    // llega por Input y el filtro de cliente no aplica (ya está acotado).
    if (this.idActivo) {
      this.configurarPermisosYBoton();
      this.setColumnas();
      await this.listar();
      return;
    }

    if (HelperService.getTipoCliente() !== 'Final') {
      this.filtros.push(this.cliente);
      this.filtros.push(this.ancestro);
    }
    this.route.params.subscribe(async (params) => {
      this.categoria = params['categoria'] as CategoriaRecordatorio;
      this.configurarPermisosYBoton();
      await this.listar();
    });

    this.setColumnas();
  }

  private configurarPermisosYBoton(): void {
    switch (this.categoria) {
      case 'Colectivo':
        this.puedeCrear = 'Colectivos - Crear recordatorios';
        this.puedeEditar = 'Colectivos - Editar recordatorios';
        this.puedeEliminar = 'Colectivos - Eliminar recordatorios';
        break;
      case 'Vehiculo':
        this.puedeCrear = 'Vehículos - Crear recordatorios';
        this.puedeEditar = 'Vehículos - Editar recordatorios';
        this.puedeEliminar = 'Vehículos - Eliminar recordatorios';
        break;
    }

    // El botón se arma recién acá, con los permisos ya resueltos
    this.botonCrear = {
      mostrar: this.helper.tienePermiso(this.puedeCrear),
      tooltip: 'Crear recordatorio',
      color: 'primary',
      tipo: 'material',
      icon: 'add',
      accion: () => this.crear(),
    };
  }

  ngOnDestroy() {
    this.recordatorios$?.unsubscribe();
  }
}
